import { Card, Button } from "react-bootstrap";
import config from '../../../../config';

const RfqDetailsHeader = ({ rfq }) => {
  const downloadPdf = () => {
    const downloadUrl = `${config.API_BASE_URL}/rfqs/${rfq._id}/pdf`;
    window.open(downloadUrl, '_blank');
  };

  return (
    <Card className="mb-4">
      <Card.Header>
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h4 className="mb-0">#{rfq.rfq_id}</h4>
            <small className="text-muted">Created: {new Date(rfq.created_at).toLocaleString()}</small>
          </div>
          <Button variant="outline-primary" onClick={downloadPdf} className="d-flex align-items-center">
            <i className="fas fa-download me-2"></i>
            Download PDF
          </Button>
        </div>
      </Card.Header>
      <Card.Body>
        <div className="row">
          <div className="col-md-6">
            <p><strong>Payment Terms:</strong> {rfq.payment_terms}</p>
            <p><strong>Raised By:</strong> {rfq.raised_by?.name || 'Procurement Team'}</p>
            <p><strong>Delivery Date:</strong> {rfq.delivery_date ? new Date(rfq.delivery_date).toLocaleDateString() : 'Not specified'}</p>
          </div>
          <div className="col-md-6">
            <p><strong>Delivery Location:</strong><br />{rfq.delivery_location || 'Not specified'}</p>
            <p><strong>Note:</strong> {rfq.note || 'No additional notes'}</p>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default RfqDetailsHeader;
